<template>
	<el-dialog title="" center :visible="show" @close="close">
		<div>
			<span class="type_size_22">{{job_name}}</span>
			<span class="type_size_18 p_flex subject_color p_m_t_20">{{num}}人提交</span>
			<div style="height: 400px;" class="overflow ">
				<div class="content_box p_b_b p_flex p_f_a p_f_b" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled">
					<span>{{item.student_name}}</span>
					<!-- 红色  subject_red-->
					<!-- 绿色  subject_color-->
					<span class="subject_color">已提交</span>
				</div>
				<!-- pagination @get="get" :index="num"/> -->
				<!-- <div class="p_flex p_f_c p_m_t_20 p_m_b_20" v-if="loading">加载中...</div>
				<div class="p_m_l_20 p_m_r_20" v-if="noMore"><el-divider>没有更多了</el-divider></div> -->
			</div>
		</div>
		<div class="p_flex p_f_c p_m_t_30" @click="goButton"><el-button type="info">关闭</el-button></div>
	</el-dialog>
</template>

<script>
import pagination from '../../../pagination/pagination.vue';
export default {
	props:{
		show:null,
		id:Number
	},
	data() {
		return {
			count:[],
			loading: false,
			num:0,
			job_name:""
		};
	},
	components:{
		pagination
	},
	watch:{
		id:{
			handler(n,o){
				this.$request.ajax(this).post("/api_teacher/publish_submit_detail",{
					job_publish_id:n
				}).then(res=>{
					// console.log(res)
					this.num=parseInt(res.data.count)
					this.job_name=res.data.job_name
					this.count=res.data.list
				})
			}
		}
	},
	computed: {
		// noMore() {
		// 	return this.count >= 20;
		// },
		// disabled() {
		// 	return this.loading || this.noMore;
		// }
	},
	mounted() {

	},
	methods: {
		get(id){
			// console.log(id)
			
		},
		// load() {
		// 	this.loading = true;
		// 	setTimeout(() => {
		// 		this.count += 2;
		// 		this.loading = false;
		// 	}, 2000);
		// },
		close() {
			this.$emit('closes', false);
		},
		goButton(){
			this.$emit('goButton', false);
		}
	}
};
</script>

<style lang="scss">
	.content_box{
		padding: 20px 0;
	}
	.subject_red{
		color: #F1282E;
	}
	
</style>



// WEBPACK FOOTER //
// src/components/homet/sent/commponents/popUp.vue